import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Flex, Box } from '@rebass/grid';

import { EMPLOYEE_CUSTOMER, mapInputLabels } from 'app/helpers/constants';
import FloatingLabelInput from 'app/ui_components/FloatingLabelInput';
import { onInputChange } from 'app/redux/actions';
import Label from 'app/ui_components/Label';

class UsfUnlockForm extends React.Component {
  static propTypes = {
    handleChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    zipcode: PropTypes.string,
    phone: PropTypes.string,
    usfEmployeeName: PropTypes.string,
    usfEmployeeEmail: PropTypes.string,
    userType: PropTypes.string,
    usfCustomerId: PropTypes.string,
    restaurantName: PropTypes.string
  };

  static defaultProps = {
    usFoods: false,
    name: '',
    email: '',
    restaurantName: '',
    zipcode: '',
    phone: '',
    usfEmployeeName: '',
    usfEmployeeEmail: '',
    usfCustomerId: ''
  };

  render() {
    const {
      handleChange,
      userType,
      name,
      email,
      phone,
      zipcode,
      usfEmployeeName,
      usfEmployeeEmail,
      restaurantName,
      usfCustomerId
    } = this.props;
    return (
      <React.Fragment>
        <Flex flexDirection="row" justifyContent="center" flexWrap="wrap">
          <Box width={1} style={{ textAlign: 'center' }}>
            <Label>
              {restaurantName} - #{usfCustomerId}
            </Label>
          </Box>
        </Flex>
        {userType === EMPLOYEE_CUSTOMER && (<React.Fragment>
          <Flex flexDirection="row" justifyContent="center" flexWrap="wrap">
            <Box width={[1, 1 / 2, 1 / 2]} pr={[2, 2, 2]} pl={[2, 0, 0]} pt={[16, 16, 16]} pb={[0, 16, 16]}>
              <FloatingLabelInput
                border
                type="text"
                placeholder={`${mapInputLabels[userType].name}*`}
                name="name"
                value={name}
                handleChange={handleChange}
                aria-label={mapInputLabels[userType].nameLabel}
                label={mapInputLabels[userType].nameLabel}
                autoFocus
              />
            </Box>
            <Box width={[1, 1 / 2, 1 / 2]} pr={[2, 0, 0]} pl={[2, 2, 2]} py={[16, 16, 16]}>
              <FloatingLabelInput
                border
                type="text"
                placeholder={`${mapInputLabels[userType].email}*`}
                name="email"
                value={email}
                handleChange={handleChange}
                label={mapInputLabels[userType].email}
                aria-label={mapInputLabels[userType].email}
              />
            </Box>
          </Flex>
          <Flex flexDirection="row" justifyContent="center" flexWrap="wrap">
            <Box width={[1, 1 / 2, 1 / 2]} pr={[2, 2, 2]} pl={[2, 0, 0]} pb={[16, 0, 0]}>
              <FloatingLabelInput
                border
                type="text"
                placeholder={`${mapInputLabels[userType].phone}*`}
                name="phone"
                value={phone}
                handleChange={handleChange}
                aria-label={mapInputLabels[userType].phone}
                label={mapInputLabels[userType].phone}
              />
            </Box>
            <Box width={[1, 1 / 2, 1 / 2]} pr={[2, 0, 0]} pl={[2, 2, 2]} pb={[16, 0, 0]}>
              <FloatingLabelInput
                border
                type="text"
                placeholder={`${mapInputLabels[userType].zipcode}*`}
                name="zipcode"
                value={zipcode}
                handleChange={handleChange}
                aria-label={mapInputLabels[userType].zipcode}
                label={mapInputLabels[userType].zipcode}
              />
            </Box>
          </Flex>
          <Flex flexDirection="row" justifyContent="center" flexWrap="wrap">
            <Box width={[1, 1 / 2, 1 / 2]} pr={[2, 2, 2]} pl={[2, 0, 0]} pt={[0, 16, 16]}>
              <FloatingLabelInput
                border
                type="text"
                placeholder={`${mapInputLabels[userType].usfEmployeeName}*`}
                name="usfEmployeeName"
                value={usfEmployeeName}
                handleChange={handleChange}
                aria-label={mapInputLabels[userType].usfEmployeeName}
                label={mapInputLabels[userType].usfEmployeeName}
              />
            </Box>
            <Box width={[1, 1 / 2, 1 / 2]} pr={[2, 0, 0]} pl={[2, 2, 2]} pt={[16, 16, 16]}>
              <FloatingLabelInput
                border
                type="text"
                placeholder={`${mapInputLabels[userType].usfEmployeeEmail}*`}
                name="usfEmployeeEmail"
                value={usfEmployeeEmail}
                handleChange={handleChange}
                aria-label={mapInputLabels[userType].usfEmployeeEmail}
                label={mapInputLabels[userType].usfEmployeeEmail}
              />
            </Box>
          </Flex>
        </React.Fragment>)}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  usFoods,
  user: { ...props }
}) => ({
  usFoods,
  ...props
});

const mapDispatchToProps = dispatch => ({
  handleChange: e => dispatch(onInputChange('user', e.target.name, e.target.value))
});

export default connect(mapStateToProps, mapDispatchToProps)(UsfUnlockForm);
